// src/contexts/WalletContext.js
import React, { createContext, useState, useContext, useEffect } from "react";
import { ethers } from "ethers";

const WalletContext = createContext();

export function WalletProvider({ children }) {
  const [walletAddress, setWalletAddress] = useState(null);
  const [network, setNetwork] = useState(null);
  const [signer, setSigner] = useState(null);

  const saveConnectionToLocalStorage = (address, networkName) => {
    localStorage.setItem("walletAddress", address);
    localStorage.setItem("network", networkName);
  };

  const loadConnectionFromLocalStorage = async () => {
    const savedAddress = localStorage.getItem("walletAddress");
    const savedNetwork = localStorage.getItem("network");
    if (savedAddress && savedNetwork && window.ethereum) {
      try {
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        setWalletAddress(savedAddress);
        setNetwork(savedNetwork);
        setSigner(signer);
      } catch (error) {
        console.error("Failed to reconnect wallet:", error);
        clearConnectionFromLocalStorage();
      }
    }
  };

  const clearConnectionFromLocalStorage = () => {
    localStorage.removeItem("walletAddress");
    localStorage.removeItem("network");
    setWalletAddress(null);
    setNetwork(null);
    setSigner(null);
  };

  useEffect(() => {
    loadConnectionFromLocalStorage();
  }, []);

  return (
    <WalletContext.Provider
      value={{
        walletAddress,
        setWalletAddress,
        network,
        setNetwork,
        signer,
        setSigner,
        saveConnectionToLocalStorage,
        clearConnectionFromLocalStorage,
      }}
    >
      {children}
    </WalletContext.Provider>
  );
}

export function useWallet() {
  return useContext(WalletContext);
}

export const WalletInfo = () => {
  const { walletAddress, network } = useWallet();
  return (
    <div className="wallet-info">
      <p>
        Connected Address:{" "}
        {walletAddress
          ? `${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`
          : "Not connected"}
      </p>
      <p>Network: {network || "Not connected"}</p>
    </div>
  );
};
